import { defineStore } from 'pinia'
import { ref } from 'vue'

interface Admin {
  id: number
  email: string
  name: string
  isSuper: boolean
  isActive: boolean
}

export const useAdminAuthStore = defineStore('adminAuth', () => {
  const token = ref<string | null>(localStorage.getItem('admin_token'))
  const admin = ref<Admin | null>(null)

  const setAuth = (newToken: string, adminData: Admin) => {
    token.value = newToken
    admin.value = adminData
    localStorage.setItem('admin_token', newToken)
    localStorage.setItem('admin_data', JSON.stringify(adminData))
  }

  const clearAuth = () => {
    token.value = null
    admin.value = null
    localStorage.removeItem('admin_token')
    localStorage.removeItem('admin_data')
  }

  const initAuth = () => {
    const storedToken = localStorage.getItem('admin_token')
    const storedAdmin = localStorage.getItem('admin_data')
    if (storedToken && storedAdmin) {
      token.value = storedToken
      admin.value = JSON.parse(storedAdmin)
    }
  }

  const isAuthenticated = () => {
    return !!token.value
  }

  return {
    token,
    admin,
    setAuth,
    clearAuth,
    initAuth,
    isAuthenticated,
  }
})
